export const DEFAULT_ENVIRONMENT = {
  requestSource: 'AOCARE',
  requestAction: 'MyAccount',
  channelCode: 'DGX',
  countryCode: 'GB',
};
